export default __webpack_public_path__ + "static/media/04__o_2.2eeec9d1.jpg";